//imports
import { all } from 'redux-saga/effects';

import authSagas from '../../auth/redux/sagas';

//merge sagas
export default function* rootSaga() {
    yield all([
        authSagas(),
    ]);
}
